import {  internal, Input } from '../../vendor/elix.js';
import EmptyValueMixin from '../mixins/empty-value-mixin.js';

class TPInput extends EmptyValueMixin(Input) {

  get type() {
    return this[internal.state].type;
  }

  set type(type) {
    this[internal.setState]({ type });
  }

  setInnerProperty(name, value) {

    if (!this.supportsInnerProperty(name)) {
      return;
    }

    super.setInnerProperty(name, value);
  }

  supportsInnerProperty(name) {

    switch(name) {
      case 'selectionEnd':
      case 'selectionStart':
        return this.type !== 'number';

      default:
        return true;
    }

  }

  get [internal.defaultState]() {
    return Object.assign(
      {},
      super[internal.defaultState],
      { type: 'text' }
    );
  }

  [internal.render](changed) {
    super[internal.render](changed);
    if (changed.type) {
      this.renderType();
    }
  }

  renderType() {
    const inner = this[internal.ids].inner;
    if (inner) {
      inner.type = this.type;
    }
  }

}

export default TPInput;
